import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

const { colors, spacing } = tokens;

export const logoHeight = 24;

export const banner = (colour: string, isWhiteBanner: boolean) => css`
  display: flex;
  align-items: center;
  height: ${logoHeight}px;
  padding: ${spacing.xxs} ${spacing.m};
  background-color: ${colour};
  box-sizing: content-box;

  ${isWhiteBanner && `border-bottom: 1px solid ${colors.neutral.trim.default};`}
`;

export const logo = css`
  display: block;
  height: ${logoHeight}px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
`;
